import React, { PureComponent } from 'react';
import { get } from 'lodash';
import Modifiers from './Modifiers';

const WHOLE = 'WHOLE';
const LEFT_SIDE = 'LEFT SIDE';
const RIGHT_SIDE = 'RIGHT SIDE';

class OrderModifiers extends PureComponent {
  groupModifiers = modifiers => {
    return modifiers.reduce(function(current, modifier) {
      let customInfo = {};
      try {
        customInfo = JSON.parse(get(modifier,'customInfo',""));
      } catch(error) {}
      if(customInfo.hasOwnProperty("portion"))
        (current[customInfo.portion] = current[customInfo.portion] || []).push(modifier);
      else
        (current[modifier.type] = current[modifier.type] || []).push(modifier);
      return current;
    }, {});
  }
  
  render() {
    const { modifiers } = this.props;
    const groupedModifiers = this.groupModifiers(modifiers);
    const forcedModifiers = groupedModifiers['forced'];
    const optionalModifiers = groupedModifiers['optional'];
    const wholeModifiers = groupedModifiers['whole'];
    const leftModifiers = groupedModifiers['left'];
    const rightModifiers = groupedModifiers['right'];
    return (
      <div>
        {forcedModifiers ? <Modifiers modifiers = {forcedModifiers}/> : null}
        {optionalModifiers ? <Modifiers modifiers = {optionalModifiers} bulletPoint = '*'/> : null}
        {wholeModifiers ? <Modifiers modifiersTitle={WHOLE} modifiers={wholeModifiers} /> : null}
        {leftModifiers ? <Modifiers modifiersTitle={LEFT_SIDE} modifiers={leftModifiers} /> : null}
        {rightModifiers ? <Modifiers modifiersTitle={RIGHT_SIDE} modifiers={rightModifiers} /> : null}
      </div>
    );
  }
}

export default OrderModifiers;



// WEBPACK FOOTER //
// ./src/views/CustomerOrderHistory/components/OrderHistoryPanel/OrderHistoryBody/ReceiptDetails/OrderModifiers.jsx